module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/young_pin_design_award-7867708b28bc9bf3298c06f320cf491c.svg&quot;;"